import { groq } from 'next-sanity';

import { sections } from './sections';

export const sectionsWithReference = groq`{
  ...(${sections}),
  _type == 'sectionReference' => {
    ...(@-> {
      "referencedSectionId": _id,
      sections[] ${sections},
    }),
  },
}`;
